import { render, staticRenderFns } from "./ListRelatorioGeracaoView.vue?vue&type=template&id=f31ad4ec&"
import script from "./ListRelatorioGeracaoView.vue?vue&type=script&lang=ts&"
export * from "./ListRelatorioGeracaoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports